/**
 * Bee Hive partner sample — sync dark/light theme across all lab layers.
 * Sets data-bh-inf-theme on <html> and every .bh-mia-lab (menu, body, footer, unified root).
 */
(function (global) {
  var STORAGE_KEY = 'muskleBeeHiveInfluencerTheme';

  function applyPartnerTheme(mode) {
    if (mode !== 'light' && mode !== 'dark') {
      mode = 'dark';
    }
    document.documentElement.setAttribute('data-bh-inf-theme', mode);
    var labs = document.querySelectorAll('.bh-mia-lab');
    for (var i = 0; i < labs.length; i++) {
      labs[i].setAttribute('data-bh-inf-theme', mode);
    }
    var coachPages = document.querySelectorAll('.muskle-bh-coach-page.bh-page');
    for (var j = 0; j < coachPages.length; j++) {
      coachPages[j].setAttribute('data-bh-inf-theme', mode);
      coachPages[j].setAttribute('data-bh-coach-theme', mode);
    }
    var influencerPages = document.querySelectorAll('.muskle-bh-influencer-page');
    for (var k = 0; k < influencerPages.length; k++) {
      influencerPages[k].setAttribute('data-bh-inf-theme', mode);
    }
    var influencerShells = document.querySelectorAll('.muskle-bh-influencer-page__shell');
    for (var m = 0; m < influencerShells.length; m++) {
      influencerShells[m].setAttribute('data-bh-inf-theme', mode);
    }
    var wellnessPages = document.querySelectorAll('.muskle-bh-partner-wellness.bh-page');
    for (var w = 0; w < wellnessPages.length; w++) {
      wellnessPages[w].setAttribute('data-bh-wellness-theme', mode);
      wellnessPages[w].setAttribute('data-bh-inf-theme', mode);
    }
    try {
      localStorage.setItem(STORAGE_KEY, mode);
      if (wellnessPages.length > 0) {
        localStorage.setItem('muskleBeeHiveWellnessTheme', mode);
      }
    } catch (e) {
      /* ignore */
    }
    return mode;
  }

  function updateToggleButton(btn, mode) {
    if (!btn) return;
    btn.setAttribute('aria-pressed', mode === 'light' ? 'true' : 'false');
    btn.textContent = mode === 'dark' ? 'DONKER' : 'LICHT';
  }

  function init(menuRoot) {
    if (!menuRoot) return;
    var btn = menuRoot.querySelector('[data-bh-inf-theme-toggle]');
    var pending = document.documentElement.getAttribute('data-bh-inf-theme-pending');
    var mode = applyPartnerTheme(
      pending === 'light' || pending === 'dark' ? pending : 'dark'
    );
    document.documentElement.removeAttribute('data-bh-inf-theme-pending');
    updateToggleButton(btn, mode);
    if (btn) {
      btn.addEventListener('click', function () {
        var cur = document.documentElement.getAttribute('data-bh-inf-theme');
        mode = applyPartnerTheme(cur === 'light' ? 'dark' : 'light');
        updateToggleButton(btn, mode);
      });
    }
  }

  global.BeeHivePartnerTheme = {
    apply: applyPartnerTheme,
    init: init,
  };
})(typeof window !== 'undefined' ? window : this);
